import { Text } from "@fluentui/react-components";
import { TextButtonProps } from "./TextButton.types";
import { PropsWithChildren } from "react";

export default function TextButton({
  onClick,
  className,
  children,
  disabled,
  ref,
}: PropsWithChildren<TextButtonProps>) {
  return (
    <button disabled={disabled} ref={ref} onClick={onClick}>
      <Text
        weight="semibold"
        className={`
          ${disabled ? "text-disabled" : "text-primary hover:text-primary-hover cursor-pointer"}
          ${className}
        `}
      >
        {children}
      </Text>
    </button>
  );
}
